/**
 * Feature flags
 *
 * Naming convention
 * -----------------
 * Env var : REACT_APP_FF_<UPPER_SNAKE_CASE>
 *   - REACT_APP_ is the required Create React App prefix for env vars exposed to the browser.
 *   - FF_ marks the variable as a feature flag so it is distinguishable from other app config
 *     in .env files.
 *
 * JS accessor : camelCase of the UPPER_SNAKE_CASE suffix.
 *   e.g. REACT_APP_FF_NO_FILES_TRANSFER  ↔  featureFlags.noFilesTransfer
 *
 * Flag semantics : a flag name should describe the capability it enables when `true`,
 *   not the UI element it rearranges.  This keeps call-site conditions readable:
 *   `if (featureFlags.noFilesTransfer) { … }` — "if no-files-transfer is enabled".
 *
 * Registry : see the "Feature flags" section in README.md for per-flag metadata
 *   (description, owner, target removal date / milestone).
 */
const isEnabled = (value: string | undefined): boolean =>
  value?.trim().toLowerCase() === "true";

export const featureFlags = {
  noFilesTransfer: isEnabled(process.env.REACT_APP_FF_NO_FILES_TRANSFER),
};
